<template>
  <div id="event">
    <div class="events">
      <div class="title">
        <h2>{{ event.name + " " + event.edition }}</h2>
      </div>

      <div class="welcome_msg">
        <span
          v-if="
            'volunteers.welcome_msg.' + formatUrl(event.name, event.edition) !=
              $t(
                'volunteers.welcome_msg.' + formatUrl(event.name, event.edition)
              )
          "
          v-html="
            $t('volunteers.welcome_msg.' + formatUrl(event.name, event.edition))
          "
        ></span>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from "@/i18n";

export default {
  name: "Event",
  data() {
    return {};
  },
  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    },

    user() {
      return this.$store.getters["getUser"];
    },

    event() {
      const events = this.$store.getters["events/getActives"];
      return events && events[this.$route.params.event_id]
        ? events[this.$route.params.event_id]
        : { name: "", edition: "" };
    }
  },
  created() {
    var self = this;
    this.$overlay.loading();
    this.$store.dispatch("persons/getVolunteer", this.user).then(() => {
      self.$store.dispatch("loadTablesRelationship").then(function() {
        self.$store.dispatch("events/loadActives", {}).then(() => {
          self.$overlay.hide();
        });
      });
    });
  },
  methods: {
    formatUrl(name, edition) {
      return name.toLowerCase().replaceAll(" ", "") + edition.substring(2);
    }
  },
  filters: {}
};
</script>

<style lang="scss" scoped>
#event {
  .welcome_msg span {
    font-size: 16px;
  }
}
</style>

<style lang="scss">
#join_popup.v-dialog {
  height: 550px !important;
}

.v-dialog {
  input.rrss {
    width: 100% !important;
    border-bottom: 2px solid #dddddd !important;
  }
}
</style>
